import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { detail, checkoutOrder } from "../services/restaurant.order.service";
import { useSearchParams } from "react-router-dom";
import { getSessionKey, handleServerValidations, isSameArray, showPrice, getSubTotalQRApp, TrimText, getTranslatedKey, pluralText, getSelectedAddons } from '../../../utils/commonfunction';
import { SWAL_SETTINGS, ORDER_STATUS, CURRENCY_SYMBOL, CONSUMPTION_TAX_RATES } from '../../../utils/Constants';
import Swal from "sweetalert2";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as $ from 'jquery';
export default function PlaceOrder() {

  const navigate = useNavigate();
  const location = useLocation();
  const [mySearchParams] = useSearchParams();
  const order_id = mySearchParams.get("order_id");
  const [orderItems, setOrderItems] = useState([...(location?.state?.selectedItems || [])]);
  const { t } = useTranslation();
  const ChargeSettings = useSelector((state) => {
    return state.QrOrderToken.ChargeSettings;
  });
  const [pricing, setPricing] = useState({
    subtotal: 0,
    tax_price: 0,
    grand_total: 0,
    service_charge: 0,
    grand_cost_price: 0
  });
  const token = getSessionKey("qr_user_token");

  useEffect(() => {
    if (!order_id) return;
    detail({ o_id: order_id }, { token })
      .then((response) => {
        if (response?.success) {
          if (response.data.order_status === ORDER_STATUS.CHECKED_OUT) {
            const mySearchParams = new URLSearchParams(window.location.search);
            mySearchParams.set("order_id", response.data?._id)
            navigate({
              pathname: "/qr-order/success",
              search: mySearchParams.toString()
            }, {
              state: {
                customerDetails: response?.data.tableOrders?.customerDetails
              }
            });
          }

          if (response.data.order_status === ORDER_STATUS.BILLED || response.data.order_status === ORDER_STATUS.COMPLETED) {
            Swal.fire({
              icon: "warning",
              text: "Order is already completed.",
              ...SWAL_SETTINGS,
            });
            const mySearchParams = new URLSearchParams(window.location.search);
            mySearchParams.delete("order_id")
            navigate({
              pathname: "/qr-order",
              search: mySearchParams.toString()
            });
          }
          handelOrderCalculations(response?.data);

        } else {
          const params = new URLSearchParams(mySearchParams);
          params.delete("order_id");
          navigate({
            pathname: "/qr-order",
            search: params.toString()
          });
        }
      })
      .catch((err) => {
        console.error(err);
        Swal.fire({
          icon: "failure",
          text: handleServerValidations(err.message),
          ...SWAL_SETTINGS,
        });
        const params = new URLSearchParams(mySearchParams);
        params.delete("order_id");
        navigate({
          pathname: "/qr-order",
          search: params.toString()
        });
      });
  }, [order_id, token]);

  const handelOrderCalculations = (orderDetail) => {
    const combinedOrderedItems = [...orderDetail.ordered_items];
    orderDetail.subOrders.forEach((subOrder) => {
      combinedOrderedItems.push(...subOrder.ordered_items);
    });
    setOrderItems(combinedOrderedItems);
  };

  useEffect(() => {
    setPricing(
      getSubTotalQRApp(orderItems, ChargeSettings, {
        handleTaxSettings: true,
      })
    );
  }, [orderItems, ChargeSettings]);

  const handelCheckout = () => {
    checkoutOrder({ o_id: order_id }, { token: token })
      .then((response) => {
        if (response.success) {
          const mySearchParams = new URLSearchParams(window.location.search);
          navigate(`/qr-order/success?${mySearchParams}`, {
            state: {
              orderDetails: response?.data.tableOrders?.customerDetails
            }
          });
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  /** */
  const toggleDetails = (id) => {
    $(`#${id}`).toggle();
  };

  /** */
  return (
    <>
      <div className='mobile-container'>
        <div className='mobile-container-wraper'>
          <div className='qr-body-wrap'>
            <div className='p-3 pt-0'>
              <div className="info-order-review mt-4 order-place-items">
                <div className="items-edit-delete">
                  <h4>Items</h4>
                  <div className="d-flex gap-2 flex-column">
                    {orderItems?.map(
                      (item, index) => {
                        return (
                          <div className="card user-select-none" key={index}>
                            <div className="p-3">
                              <div className="d-flex align-items-center justify-content-between">
                                <div className={getSelectedAddons(item)?.length || item?.notes ? "cp" : ""} onClick={() => {
                                  if (getSelectedAddons(item)?.length || item?.notes) {
                                    toggleDetails(item.preference_id)
                                  }
                                }} >
                                  <span className="d-block">
                                    {getTranslatedKey("item_name", item)} <strong>(x{item?.quantity})</strong>{" "}
                                    <br />
                                  </span>
                                </div>
                                <div>
                                  <div className="d-flex gap-2">
                                    <div className="d-flex align-items-center">
                                      <span>
                                        {showPrice((item?.price + (item?.addon_price || 0)) * item?.quantity)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {
                              getSelectedAddons(item)?.length || item?.notes ?
                                <div id={item.preference_id} style={{ display: 'none' }} className="p-3 pt-0">
                                  <div>
                                    {
                                      getSelectedAddons(item)?.length ?
                                        <div className="modifiers-view">
                                          <span className="d-block text-primary">Selected modifiers</span>
                                          {
                                            getSelectedAddons(item)?.map((addon, index) => {
                                              return <span className="d-block" key={index}>{addon?.item_name}</span>;
                                            })
                                          }
                                        </div>
                                        : null
                                    }
                                    {item?.notes ?
                                      <span className="d-block mb-2">{item?.notes}</span>
                                      : null
                                    }

                                  </div>
                                </div>
                                : null
                            }

                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>

              <div className="info-order-review mt-4">
                <div className="card card-2">
                  <div className="p-2">
                    <table width={"100%"} className='d-none'>
                      <tbody>
                        <tr>
                          <td>
                            {t("restaurant.table_management.sub_total_label")}{" "}(x{orderItems?.length})
                          </td>
                          <td className="text-end">
                            {CURRENCY_SYMBOL}&nbsp;
                            {showPrice(pricing?.subtotal)}
                          </td>
                        </tr>
                        {console.log("ChargeSettings", ChargeSettings, pricing?.service_charge)}
                        {pricing?.service_charge && ChargeSettings?.is_service_charge_enabled ? (
                          <tr>
                            <td>{t("qr_code.service_charges")}</td>
                            <td className="text-end">
                              {CURRENCY_SYMBOL} {showPrice(pricing?.service_charge)}
                            </td>
                          </tr>
                        ) : null}
                        {pricing?.addOnPrice ? (
                          <tr>
                            <td>{t("Add On Price")}</td>
                            <td className="text-end">
                              {CURRENCY_SYMBOL} {showPrice(pricing?.addOnPrice)}
                            </td>
                          </tr>
                        ) :
                          <tr>
                            <td>{t("Add On Price")}</td>
                            <td className="text-end">
                              {CURRENCY_SYMBOL} {"0.00"}
                            </td>
                          </tr>
                        }
                        {pricing?.tax_price ? (
                          <tr>
                            <td>{t("qr_code.total_tax_label")}</td>
                            <td className="text-end">
                              {CURRENCY_SYMBOL} {showPrice(pricing?.tax_price)}
                            </td>
                          </tr>
                        ) : null}
                        <tr>
                        </tr>
                        <tr>
                          <td>
                            <h4>{t("restaurant.table_management.grand_total_text")}</h4>
                          </td>
                          <td className="text-end">
                            <h4>{CURRENCY_SYMBOL} {showPrice(pricing?.grand_total)}</h4>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table width={"100%"}>
                      <tbody>
                        <tr>
                          <td>
                            Subtotal (
                            {orderItems?.length}{" "}
                            {pluralText(
                              orderItems?.length,
                              "Item",
                              "Items"
                            )}
                            )
                          </td>
                          <td className="text-end">
                            {CURRENCY_SYMBOL} {showPrice(pricing?.subtotal)
                            }
                          </td>
                        </tr>

                        {pricing?.service_charge ? (
                          <tr>
                            <td>Service Charge ({ChargeSettings?.service_charge}%)</td>
                            <td className="text-end">
                              {CURRENCY_SYMBOL} {showPrice(pricing?.service_charge)}
                            </td>
                          </tr>
                        ) : null}

                        {pricing?.tax_price ? (
                          <tr>
                            <td>VAT</td>
                            <td className="text-end">
                              {CURRENCY_SYMBOL} {showPrice(pricing?.tax_price)}
                            </td>
                          </tr>
                        ) : null}

                        <tr>
                          <td>
                            <h3>Total</h3>
                          </td>
                          <td className="text-end">
                            <h3>{CURRENCY_SYMBOL} {showPrice(pricing?.grand_total)}</h3>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cart-bottom p-3">
            <button className="btn btn-primary w-100" onClick={() => {
              const searchParams = window.location.search;
              navigate(`/qr-order${searchParams}`)
            }}>Want to add more items?</button>
            <button className="btn btn-dark w-100 mt-2" data-bs-toggle="modal" data-bs-target="#exampleModal" >Checkout</button>
          </div>

          <div className="modal fade qr-modal" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className='qr-confirm-modal'>
                    <figure className='text-center'>
                      <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="47.5" cy="47.5" r="47" fill="#F8821B" fillOpacity="0.13" />
                        <g clipPath="url(#clip0_2738_3873)">
                          <path d="M44.1875 74C46.0169 74 47.5 72.5169 47.5 70.6875C47.5 68.8581 46.0169 67.375 44.1875 67.375C42.3581 67.375 40.875 68.8581 40.875 70.6875C40.875 72.5169 42.3581 74 44.1875 74Z" fill="#F8821B" />
                          <path d="M61.8545 74C63.6839 74 65.167 72.5169 65.167 70.6875C65.167 68.8581 63.6839 67.375 61.8545 67.375C60.025 67.375 58.542 68.8581 58.542 70.6875C58.542 72.5169 60.025 74 61.8545 74Z" fill="#F8821B" />
                          <path d="M74.0003 35.3542C74.0003 43.2688 67.5608 49.7083 59.6462 49.7083C51.7315 49.7083 45.292 43.2688 45.292 35.3542C45.292 27.4395 51.7315 21 59.6462 21C67.5608 21 74.0003 27.4395 74.0003 35.3542ZM66.6201 28.7248C66.1791 28.3397 65.6033 28.1453 65.0192 28.1842C64.435 28.2231 63.8901 28.4922 63.5041 28.9323L57.3296 35.9902L54.5825 33.243C54.1684 32.8289 53.6068 32.5963 53.0212 32.5963C52.4356 32.5963 51.8739 32.8289 51.4599 33.243C51.0458 33.6571 50.8132 34.2187 50.8132 34.8043C50.8132 35.3899 51.0458 35.9515 51.4599 36.3656L55.8765 40.7823C56.0902 40.9959 56.3455 41.1634 56.6266 41.2744C56.9076 41.3855 57.2085 41.4376 57.5105 41.4277C57.8125 41.4177 58.1093 41.3459 58.3824 41.2167C58.6556 41.0874 58.8993 40.9035 59.0985 40.6763L66.8277 31.8429C67.0189 31.6246 67.1653 31.3708 67.2584 31.0959C67.3515 30.821 67.3895 30.5304 67.3703 30.2408C67.351 29.9512 67.2748 29.6682 67.1461 29.4081C67.0174 29.148 66.8386 28.9158 66.6201 28.7248Z" fill="#F8821B" />
                          <path d="M40.8754 35.3555C40.8754 34.9823 40.9085 34.6179 40.9306 34.2513H35.0432L34.204 30.2631C33.9125 28.9068 33.1676 27.6904 32.0922 26.8141C31.0169 25.9378 29.675 25.4539 28.2879 25.4423L22.6633 25.418H22.6566C22.2174 25.4171 21.7957 25.5907 21.4845 25.9007C21.1733 26.2107 20.998 26.6316 20.9971 27.0709C20.9962 27.5102 21.1698 27.9318 21.4798 28.243C21.7898 28.5543 22.2107 28.7296 22.65 28.7305L28.2724 28.7548C29.5643 28.7592 30.695 29.6823 30.9622 30.9454L32.0774 36.2476L36.0745 55.2305H34.8025C32.0619 55.2305 29.8337 57.4587 29.8337 60.1992C29.8337 62.9398 32.0619 65.168 34.8025 65.168H67.9275C68.3667 65.168 68.788 64.9935 69.0986 64.6829C69.4092 64.3723 69.5837 63.951 69.5837 63.5117C69.5837 63.0725 69.4092 62.6512 69.0986 62.3406C68.788 62.03 68.3667 61.8555 67.9275 61.8555H34.8025C34.3632 61.8555 33.9419 61.681 33.6313 61.3704C33.3207 61.0598 33.1462 60.6385 33.1462 60.1992C33.1462 59.76 33.3207 59.3387 33.6313 59.0281C33.9419 58.7175 34.3632 58.543 34.8025 58.543H67.9275C68.3076 58.5426 68.676 58.4116 68.9711 58.172C69.2661 57.9324 69.4699 57.5987 69.5484 57.2268L71.0169 50.2551C67.7573 52.7642 63.7597 54.1252 59.6462 54.1263C49.2958 54.1263 40.8754 45.7059 40.8754 35.3555Z" fill="#F8821B" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2738_3873">
                            <rect width="53" height="53" fill="white" transform="translate(21 21)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </figure>
                    <h4 className='text-center my-4'>Are You sure want to checkout?</h4>
                    <div className='d-flex gap-3'>
                      <button className='btn btn-gry w-100' data-bs-dismiss="modal">No</button>
                      <button className='btn btn-primary w-100' onClick={handelCheckout} data-bs-dismiss="modal">Yes</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}